export const eyeCampConsultationListTranslations = {
    en: {
        title: "Eye Camp Consultations",
        subtitle: "Beneficiary screenings recorded for this camp",
        noData: "No consultations found",
        loading: "Loading...",
        srNo: "Sr. No.",
        tokenNo: "Token No",
        beneficiaryName: "Beneficiary Name",
        gender: "Gender",
        status: "Status",
        visionRe: "Vision RE",
        visionLe: "Vision LE",
        glassesRe: "Glasses RE (Sph/Cyl/Axis)",
        glassesLe: "Glasses LE (Sph/Cyl/Axis)",
        nearAdd: "Near Add",
        surgeryTypes: "Surgery Types",
        diagnosticTypes: "Diagnostic Types",
        advice: "Advice",
        refractive: "Refractive",
        therapeutic: "Therapeutic",
        diagnostic: "Diagnostic",
    },
    mr: {
        title: "नेत्र शिबिर सल्लामसलत",
        subtitle: "या शिबिरासाठी नोंदविलेले लाभार्थी तपासणी",
        noData: "कोणतीही सल्लामसलत आढळली नाही",
        loading: "लोड होत आहे...",
        srNo: "अ. क्र.",
        tokenNo: "टोकन क्रमांक",
        beneficiaryName: "लाभार्थीचे नाव",
        gender: "लिंग",
        status: "स्थिती",
        visionRe: "दृष्टी (उजवा डोळा)",
        visionLe: "दृष्टी (डावा डोळा)",
        glassesRe: "चष्मा (उजवा डोळा)",
        glassesLe: "चष्मा (डावा डोळा)",
        nearAdd: "निअर अ‍ॅड",
        surgeryTypes: "शस्त्रक्रिया प्रकार",
        diagnosticTypes: "निदान प्रकार",
        advice: "सल्ला",
        refractive: "अपवर्तक",
        therapeutic: "उपचारात्मक",
        diagnostic: "निदानात्मक",
    },
};
